import { Directive, DoCheck, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numeroProcessoMask]'
})
export class NumeroProcessoMaskDirective implements DoCheck {

  constructor(private ngControl: NgControl) {}

  ngDoCheck() {
    const control = this.ngControl.control;
    if (control && control.value != null) {
      this.aplicarMascara(control.value);
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    this.aplicarMascara(event.target.value || '');
  }

  private aplicarMascara(valor: any) {
    let value = String(valor).replace(/\D/g, '').substring(0, 20);
    if (value.length > 7) {
      value = value.replace(/^(\d{7})(\d)/, '$1-$2');
    }
    if (value.length > 10) { // 7 + 1 (-) + 2 = 10 -> 0000000-00.
      value = value.replace(/^(\d{7}-\d{2})(\d)/, '$1.$2');
    }
    if (value.length > 15) { // 10 + 1 (.) + 4 = 15 -> 0000000-00.0000.
      value = value.replace(/^(\d{7}-\d{2}\.\d{4})(\d)/, '$1.$2');
    }
    if (value.length > 17) { // 15 + 1 (.) + 1 = 17 -> 0000000-00.0000.0.
      value = value.replace(/^(\d{7}-\d{2}\.\d{4}\.\d{1})(\d)/, '$1.$2');
    }
    if (value.length > 20) { // 17 + 1 (.) + 2 = 20 -> 0000000-00.0000.0.00.
      value = value.replace(/^(\d{7}-\d{2}\.\d{4}\.\d{1}\.\d{2})(\d)/, '$1.$2');
    }

    const control = this.ngControl.control;
    if (control && control.value !== value) {
      control.setValue(value, { emitEvent: false });
    }
  }
}
